import Router from "./Router";

export default function NavigationContainer() {

  return (
    <>
      {/* <NotificationBanner /> */}
      <Router />
    </>
  );
}
